/* eslint-disable spire/fenced-imports */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { TextFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { EditorTemplateProps } from "@insite/shell-public/EditorTemplateProps";
import ShellState from "@insite/shell/Store/ShellState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
/* eslint-enable spire/fenced-imports */

type OwnProps = EditorTemplateProps<string, TextFieldDefinition>;

const mapStateToProps = (_: ShellState, __: OwnProps) => ({});

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

class CustomLabelField extends React.Component<Props> {
    render() {
        const { fieldDefinition } = this.props;

        return (
            <StyledWrapper
                css={css`
                    margin-top: 20px;
                `}
            >
                {fieldDefinition.displayName ?? fieldDefinition.name}
            </StyledWrapper>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomLabelField as never);
